import React, { createContext, useContext, useMemo } from 'react';
import { useAudioStream } from '../hooks/useAudioStream';
import { useNowPlaying } from '../hooks/useNowPlaying';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PlayerContext = createContext(null);

export const PlayerProvider = ({ children }) => {
  const { nowPlaying, refreshMeta } = useNowPlaying(API);
  const { playing, loading, volume, setVolume, play, stop, toggle } =
    useAudioStream(nowPlaying.stream_url);

  const value = useMemo(
    () => ({
      playing,
      loading,
      volume,
      setVolume,
      nowPlaying,
      refreshMeta,
      play,
      stop,
      toggle,
    }),
    [playing, loading, volume, setVolume, nowPlaying, refreshMeta, play, stop, toggle]
  );

  return <PlayerContext.Provider value={value}>{children}</PlayerContext.Provider>;
};

export const usePlayer = () => {
  const ctx = useContext(PlayerContext);
  if (!ctx) throw new Error('usePlayer must be inside PlayerProvider');
  return ctx;
};
